export default __webpack_public_path__ + "static/media/44.afe8ef42.jpg";